import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';

@Component({
  selector: 'app-sperm-retrieval-techniques',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './sperm-retrieval-techniques.component.html',
  styleUrl: './sperm-retrieval-techniques.component.scss'
})
export class SpermRetrievalTechniquesComponent implements OnInit {

  constructor(private route: Router, private metaService: Meta,
    private titleService: Title, private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    const homeSchema = {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "NCare IVF Kannur, Kerala",
      "image": "https://ncareivfkannur.com/assets/images/header/logo.svg",
      "@id": "https://ncareivfkannur.com/",
      "url": "https://ncareivfkannur.com/sperm-retrieval-techniques",
      "telephone": "8606443030",
      "priceRange": "₹",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Balram Memorial Buidling, N.E, Rajiv Gandhi Rd",
        "addressLocality": "Kannur, Kerala",
        "postalCode": "670001",
        "addressCountry": "IN"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 11.8710259,
        "longitude": 75.3641411
      },
      "sameAs": [
        "https://www.facebook.com/people/Ncare-IVF-Kannur/61574105283962/",
        "https://www.instagram.com/ncareivfkannur/",
        "https://www.youtube.com/@NCAREIVFKANNUR/"
      ]
    }


    const script = this.renderer.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(homeSchema);
    this.renderer.appendChild(this.document.head, script);



    this.titleService.setTitle('Sperm Retrieval Techniques | Advanced Male Infertility Treatment ');
    this.metaService.updateTag({
      name: 'description',
      content: 'Advanced sperm retrieval techniques at NCARE IVF Centre in Kannur. We offer effective treatments for male infertility including PESA, TESA, MESA & Micro-TESE. Book a consultation today.'
    });

    this.metaService.updateTag({
      name: 'keywords',
      content: 'Sperm Retrieval Procedures, sperm retrieval techniques'
    });

    this.metaService.updateTag({
      property: 'og:title',
      content: 'Sperm Retrieval Techniques | Advanced Male Infertility Treatment '
    });

    this.metaService.updateTag({
      property: 'og:description',
      content: 'Advanced sperm retrieval techniques at NCARE IVF Centre in Kannur. We offer effective treatments for male infertility including PESA, TESA, MESA & Micro-TESE. Book a consultation today.'
    });
  }
  contactus() {
    this.route.navigate(['/contact-us']);
  }

}
